// 2_components/header.js
// Moves the top-navigation contacts and a custom account button into the
// header top bar, and toggles the sticky header on scroll direction
// (skipped during the ordering process).

let headerTop;
let topNavigationContacts;

export function init() {
	if (!window.NAT?.utils?.addSmartTouchClickListener) {
		console.warn("[NAT] header.js: window.NAT.utils.addSmartTouchClickListener missing — check load order");
		return;
	}

	const header = document.getElementById("header");
	headerTop = header.querySelector(".header-top");
	topNavigationContacts = document.querySelector(".top-navigation-contacts");

	addContactToHeaderTop();
	addAccountToHeaderTop();
	stickyHeaderToggle();
	closeLoginWidgetOnOutsideClick();
}

function addContactToHeaderTop() {
	headerTop.appendChild(topNavigationContacts);
	headerTop.classList.add("header-loaded");

	const projectPhone = headerTop.querySelector(".project-phone");

	const contactHoursSpan = document.createElement("span");
	contactHoursSpan.className = "contact-hours";

	projectPhone.innerHTML = projectPhone.innerHTML.replace(window.NAT.translations("phoneCode"), "");
	contactHoursSpan.innerHTML = window.NAT.translations("contactHours");

	projectPhone.appendChild(contactHoursSpan);
}

function addAccountToHeaderTop() {
	const accountButton = document.createElement("a");
	accountButton.className = "login-button-custom";
	accountButton.setAttribute("data-target", "login");
	accountButton.setAttribute("href", window.NAT.translations("clientUrl"));
	headerTop.appendChild(accountButton);

	const originalAccountButton = document.querySelector(".top-navigation-tools .top-nav-button-login");
	if (originalAccountButton) {
		window.NAT.utils.addSmartTouchClickListener(accountButton, function (event) {
			event.preventDefault();
			originalAccountButton.click();
		});
	}
}

function closeLoginWidgetOnOutsideClick() {
	document.addEventListener("click", function (event) {
		if (!document.body.classList.contains("login-window-visible")) return;
		if (event.target.closest("#login.login-widget")) return;
		if (event.target.closest("[data-target='login']")) return;
		document.body.classList.remove("login-window-visible");
	});
}

function stickyHeaderToggle() {
	const header = document.getElementById("header");
	if (!header) return;

	const body = document.body;
	if (body.classList.contains("ordering-process")) return;

	let lastScrollPosition = 0;
	let lastScrollUp = 0;
	let lastScrollDown = 0;
	let scrolledUp = false;

	const headerHeight = header.offsetHeight;
	const headerTopPosition = header.getBoundingClientRect().top + window.pageYOffset;
	const scrollThreshold = 150;

	let scrollDifference = 0;

	const handleScroll = () => {
		if (document.body.classList.contains("raventic-search-dropdown-open")) return;

		const currentScrollPosition = Math.round(window.pageYOffset || document.documentElement.scrollTop);

		// Scrolling up
		if (currentScrollPosition < lastScrollPosition) {
			lastScrollUp = currentScrollPosition;

			if (scrollDifference > scrollThreshold) {
				deactivateStickyHeader();
				scrolledUp = true;
			}
			if (currentScrollPosition <= headerTopPosition) {
				// If scrolled to the top
				removeStickyHeader();

				scrolledUp = false;
			}
		}
		// Scrolling down
		else {
			lastScrollDown = currentScrollPosition;
			scrollDifference = lastScrollDown - lastScrollUp;
			if (currentScrollPosition > headerHeight && scrollDifference > scrollThreshold) {
				if (scrolledUp) {
					activateStickyHeader();
				} else {
					document.body.classList.add("scrolled-down");
				}
			}
		}

		lastScrollPosition = Math.max(currentScrollPosition, 0); // Prevent negative scroll
	};

	const activateStickyHeader = () => {
		document.body.classList.add("scrolled-down");
		document.body.classList.add("sticky-header-off");
		document.body.classList.remove("sticky-header-on");
	};

	const deactivateStickyHeader = () => {
		document.body.classList.add("sticky-header-on");
		document.body.classList.remove("sticky-header-off");
		document.body.classList.remove("scrolled-down");
	};

	const removeStickyHeader = () => {
		document.body.classList.remove("sticky-header-on");
		document.body.classList.remove("sticky-header-off");
	};

	window.addEventListener("scroll", handleScroll);
}
